import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';

type MobileAppLinksResponse = {
    qrcodeUrl: string;
    iosStoreUrl: string;
    androidStoreUrl: string;
};

export class MobileAppLinksRepository {
    async getLinks(): Promise<HttpServiceResponse<MobileAppLinksResponse>> {
        return context.httpService.get(context.registry.entries.mobileAppLinks());
    }
}
